import React, { useMemo, useCallback, useState } from "react";
import gensetImage from "../images/Genset-image-SE.jpg";
import batteryImage from "../images/BESS-image-SE.png";
import pvCL60SE from "../images/CL60_SE.jpg";
import pvCL36SE from "../images/CL36_SE.jpg";
import pvCL125SE from "../images/CL125_SE.jpg";

const AssetSelectionDER = ({
  assetInfo,
  cbDer,
  onSelectManufacturer,
  closeAssetSelectionBlock,
  onSelectAssetInModal,
  CBLoadList,
  defaultsMinMax,
  projectKind,
  switchboardType,
  remoteMain,
  selectedValues,
  isSelectSpanishCode
}) => {
  const [disabledAssetErrorPopUp, setDisabledAssetErrorPopUp] = useState(false);
  const [selectedAssetValue, setSelectedAssetValue] = useState("");
  const [loadCountError, setLoadCountError] = useState(false);
  const [selectedAssetData,setSelectedAssetData] = useState({});
  const checkLoadHardwireLimit = (maxLoad) => {
    let hardwireCount = 0;
  
    CBLoadList.slice(0, maxLoad).forEach(data => {
      if (data?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired" || data?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Serial") {
        hardwireCount++;
      }
    });
    return hardwireCount;
  }

  const handleCheckBoxChange = useCallback(e => {
    const selectedId = e.target.value;
    let enabledStatus = false;
    let selectedData = {};
    assetInfo.assets.forEach(data => {
      if (String(selectedId) === String(data.assetId)) {
        enabledStatus = data.assetEnabled;
        selectedData = data;
      }
    });
    if (enabledStatus) {
      setSelectedAssetValue(selectedId);
      setSelectedAssetData(selectedData);
    } else {
      setSelectedAssetValue("");
      setDisabledAssetErrorPopUp(true);
    }
  }, [assetInfo.assets]);
  const closePopUpAlertAsset = () => {
    setDisabledAssetErrorPopUp(false);
  };

  const closePopUpLoadAlertAsset = () => {
    setLoadCountError(false);
  };


  const assetSelectedFromList = () => {
    const maxLoadCount = defaultsMinMax?.maxLoad || 0;
    if(selectedAssetData?.assetInfo !== "Communicating" && maxLoadCount !== 0 && checkLoadHardwireLimit(parseInt(maxLoadCount)) === parseInt(maxLoadCount)){
      setLoadCountError(true);
      return;
    }
    onSelectAssetInModal(selectedAssetValue);
    setSelectedAssetValue("");
  };
  const isRemoteLoad = (load) => {
    if (!load || !load?.uiData || typeof load?.uiData?.isRemoteLoad !== 'boolean') {
        console.warn('Invalid load object structure or missing isRemoteLoad property');
        return false;
    }
    return load?.uiData?.isRemoteLoad;
};
  const { filteredAssets, isHardwired } = useMemo(() => {
  if (cbDer === "EV") {
    return { filteredAssets: assetInfo?.assets?.filter(asset => asset?.assetInfo !== "Hardwired") || [], isHardwired: false };
  }

  const assets = assetInfo?.assets || [];
  const isGenset = assets.some(asset =>( asset.assetType).toLocaleLowerCase() === "generator");
  const isDaaSOrMgaaS = projectKind?.isDaasAnsi || projectKind?.isDaasEto  || projectKind?.isMgaasAnsi;
  const isExistingSwitchboard = switchboardType === 'EXISTING_SWITCHBOARD';
  const selectedAssetCB = selectedValues?.selectedAssetCB;
  const selectedLoadCB = selectedValues?.selectedLoadCB;
  const selectedPM = selectedValues?.selectedAssetPM;
  if(isGenset){
     return { filteredAssets: assets, isHardwired: false };
  }
  if(selectedPM === 0 && isSelectSpanishCode){
    const pmAsset = assets.filter(pmAsset=>pmAsset.communicationModel === "PM8244");
    return { filteredAssets: pmAsset, isHardwired: false };
  }

  if (isDaaSOrMgaaS) {
    if (switchboardType === 'NEW_SWITCHBOARD' || 
        (isExistingSwitchboard && [1, 2, 3, 4, 5].includes(selectedAssetCB)) || 
        (isExistingSwitchboard && selectedLoadCB !== "" && !isRemoteLoad(CBLoadList[selectedLoadCB])) || 
        (isExistingSwitchboard && !remoteMain && [0].includes(selectedAssetCB))) {
      return { filteredAssets: assets.filter(asset => asset?.assetInfo === "Communicating"), isHardwired: true };
    } else if (isExistingSwitchboard && remoteMain && [0].includes(selectedAssetCB)) {
      return { filteredAssets: { filteredAssets: assets, isHardwired: false }, isHardwired: false }; 
    }
  }

  return { filteredAssets: assets, isHardwired: false }; 
},[assetInfo, projectKind, switchboardType, selectedValues, CBLoadList, remoteMain, cbDer, isSelectSpanishCode]);

const checkIsAcCoupledPcu = (asset) =>{
   let isacCoulpedPcu = asset?.assetAttributes?.filter(
    (item) => item?.type === "isacCoulpedPcu"
  )[0]?.value;
  isacCoulpedPcu =
    typeof isacCoulpedPcu === "string" ? JSON.parse(isacCoulpedPcu) : false;
  return isacCoulpedPcu;
}

const matchingAssets = assetInfo.selectedManufacturer !== "" 
  ? filteredAssets?.filter(data => assetInfo.selectedManufacturer === data.manufacturer) || []
  : [];

  return (
    <se-dialog
      id="dialog-complex"
      size="large"
      open={assetInfo.assetSelected}
      can-backdrop="false"
      className="modal-z-index"
    >
      <se-dialog-header>Asset Selection</se-dialog-header>

      <se-dialog-content className="se-dialog-content">
        <se-loading loading={assetInfo.manufacturerLoading}></se-loading>
        <div className="container se-custom-container-popup">
          <div className="row se-grey-background pl-1 sticky">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
              <div className="form-group row">
                <label
                  htmlFor="manufacturer"
                  className="col-sm-3 col-form-label bold"
                >
                  Asset Manufacturer 
                </label>
                <div className="col-sm-9">
                  <select
                    id="manufacturer"
                    className="form-control form-control-sm"
                    value={assetInfo.selectedManufacturer}
                    onChange={onSelectManufacturer}
                  >
                    <option value="" disabled defaultValue hidden>
                      Select Manufacturer
                    </option>
                    {assetInfo.assetManufacturer.map((data, idx) => (
                      <option key={idx} value={data} style={{display:data === "Generic" && isHardwired?"none":"block"}}  >
                        {data}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            
            {assetInfo.selectedManufacturer !== ""
              ? matchingAssets.length > 0 ? (
                  matchingAssets.map((data, index) => (
                      <div
                        className={`col-sm-12 col-md-12 col-lg-12 col-xl-12 border-bottom ${checkIsAcCoupledPcu(data) && projectKind?.isMgaasIec?"der-disabled":""}`}
                        key={data.assetId}
                      >
                        <div className="row mt-1 mb-1 ">
                          <div className="col-sm-1 col-md-1 col-lg-1 col-xl-1 d-flex align-items-center ">
                            <div className="custom-control custom-radio">
                              <input
                                type="radio"
                                className={`custom-control-input asCompatible ${checkIsAcCoupledPcu(data) && projectKind?.isMgaasIec?"der-disabled":""}`}
                                value={data.assetId}
                                name="assetSelection"
                                id={data.assetId}
                                checked={String(selectedAssetValue) === String(data.assetId)}
                                onChange={handleCheckBoxChange}
                                disabled ={checkIsAcCoupledPcu(data) && projectKind?.isMgaasIec?true:false}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={data.assetId}
                              ></label>
                            </div>
                          </div>
                          {data.imageLink !== null ? (
                            <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mt-2 ">
                              <img
                              className="asset-image"
                                src={data.imageLink}
                                alt={data.manufacturer}
                                height="65px"
                                width="65px"
                              />
                            </div>
                          ) : (
                            <div className="col-sm-2 col-md-2 col-lg-2 col-xl-2 mt-2">
                              {data.assetType === "BESS" &&
                                data.manufacturer === "SCHNEIDER ELECTRIC" ? (
                                <img
                                 className="asset-image"
                                  src={batteryImage}
                                  alt="SCHNEIDER ELECTRIC"
                                  height="65px"
                                />
                              ) : data.assetType === "BESS" ? (
                                <se-icon color="primary" size="xlarge">
                                  battery2_half
                                </se-icon>
                              ) : (
                                ""
                              )}

                              {data.assetType === "Generator" &&
                                data.manufacturer === "STANDARD GENSET TEMPLATE" ? (
                                <img
                                 className="asset-image"
                                  src={gensetImage}
                                  height="65px"
                                  alt="STANDARD GENSET TEMPLATE"
                                />
                              ) : data.assetType === "Generator" ? (
                                <se-icon color="primary" size="xlarge">
                                  diesel_generator
                                </se-icon>
                              ) : (
                                ""
                              )}

                              {data.assetType === "PV_inverter" &&
                                data.manufacturer === "SCHNEIDER ELECTRIC" ? (
                                data.communicationModel === "CONEXT CL36" ? (
                                  <img
                                   className="asset-image"
                                    src={pvCL36SE}
                                    height="65px"
                                    alt="CONEXT CL36"
                                  />
                                ) : data.communicationModel === "CONEXT CL60" ? (
                                  <img
                                   className="asset-image"
                                    src={pvCL60SE}
                                    height="65px"
                                    alt="CONEXT CL60"
                                  />
                                ) : data.communicationModel === "CONEXT CL125" ? (
                                  <img
                                    src={pvCL125SE}
                                    height="65px"
                                    alt="CONEXT CL125"
                                  />
                                ) : data.communicationModel === "CONEXT CL25" ? (
                                  <img
                                   className="asset-image"
                                    src={pvCL60SE}
                                    height="65px"
                                    alt="CONEXT CL25"
                                  />
                                ) : (
                                  <se-icon color="primary" size="xlarge">
                                    solar_panel1
                                  </se-icon>
                                )
                              ) : data.assetType === "PV_inverter" ? (
                                <se-icon color="primary" size="xlarge">
                                  solar_panel1
                                </se-icon>
                              ) : (
                                ""
                              )}
                            </div>
                          )}

                          <div className="col-sm col-md col-lg col-xl">
                            <div className="row">
                              <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 bold">
                                {data.manufacturer}
                              </div>
                              <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4 bold">
                                {data.communicationModel}
                              </div>
                              {data.assetProperties.map(
                                (properties, indexProp) => (
                                  <div key={indexProp} className="col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                                    {properties.type}: {properties.value}
                                  </div>
                                )
                              )}
                            </div>
                            <div className="row mt-1 mb-1 ">
                              {data.assetEnabled === true ? (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                  <span>{data.comments}</span>
                                </div>
                              ) : (
                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-info-disable">
                                  <se-icon color="standard" size="small">
                                    information_stroke{" "}
                                  </se-icon>
                                  {data.comments.trim() === "" ? (
                                    <span>
                                      Not available as standard, Contact
                                      Schneider-Electric support team for
                                      integration in your application or
                                      {data.assetType === "Generator"
                                        ? ' use "Standard genset template" '
                                        : data.assetType === "BESS"
                                          ? ' use "Schneider Electric" BESS'
                                          : data.assetType === "PV_inverter"
                                            ? ' use "Schneider Electric" or Standard PV Inverter Template'
                                            : ""}{" "}
                                      model
                                    </span>
                                  ) : (
                                    <span>{data.comments}</span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-sm-12 mt-3 p-3 text-center">
                       <span className=" text-muted">No assets available for this manufacturer.</span>
                    </div>
                  )
              : null}
          </div>
        </div>

        <se-dialog
          id="dialog-asset-select-alert"
          size="small"
          can-backdrop="false"
          open={disabledAssetErrorPopUp}
        >
          <se-dialog-content icon="information_stroke" icon-color="primary">
            Not available as standard, Contact Schneider-Electric support team
            for integration in your application.
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={closePopUpAlertAsset}>OK</se-button>
          </se-dialog-footer>
        </se-dialog>
        <se-dialog
          id="dialog-load-count-alert"
          size="small"
          can-backdrop="false"
          open={loadCountError}
        >
          <se-dialog-content icon="information_stroke" icon-color="primary">
          {`The first ${defaultsMinMax?.maxLoad} loads already have Hardwired/Serial circuit breakers.`}
          </se-dialog-content>
          <se-dialog-footer>
            <se-button onClick={closePopUpLoadAlertAsset}>OK</se-button>
          </se-dialog-footer>
        </se-dialog>
      </se-dialog-content>
      <se-dialog-footer>
        <se-button onClick={closeAssetSelectionBlock}>Cancel</se-button>

        <se-button
          disabled={selectedAssetValue ? "false" : "true"}
          onClick={assetSelectedFromList}
          color="primary"
        >
          Select
        </se-button>
      </se-dialog-footer>
    </se-dialog>
  );
};

export default AssetSelectionDER;
